const delayIn = 300;
const delayButtonTextIn = 150;

export { delayIn, delayButtonTextIn };
